module.exports = __webpack_public_path__ + "img/3dc.6ca64bf9.png";